import { render, staticRenderFns } from "./clipboard_events_component.vue?vue&type=template&id=08719207&scoped=true&"
import script from "../assets/js/clipboardEventsComponent.js?vue&type=script&lang=js&"
export * from "../assets/js/clipboardEventsComponent.js?vue&type=script&lang=js&"
import style0 from "./clipboard_events_component.vue?vue&type=style&index=0&id=08719207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08719207",
  null
  
)

export default component.exports